import loadable from "@loadable/component";

export const DevicesList = loadable(() => import("./devices-list"), {
  resolveComponent: ({ DevicesList }) => DevicesList,
});

export const DevicesDetails = loadable(() => import("./devices-details"), {
  resolveComponent: ({ DevicesDetails }) => DevicesDetails,
});
